import { Card, Col, Flex, Row, Spin } from 'antd'
import dayjs from 'dayjs'
import { useParams } from 'react-router-dom'

import { useInstitutionServiceGetDeviceEndpoint } from 'src/api/queries'
import { PageBreadcrumbs, Text } from 'src/components'
import { dayMonthYearFormatWithDot } from 'src/libs'
import { useLocales } from 'src/locales'

import { TechnicalInspectionsCard } from '../components'

export const EquipmentDetailsPage = () => {
  const { t, currentLang } = useLocales()
  const { id } = useParams()

  const { data, isLoading } = useInstitutionServiceGetDeviceEndpoint(
    {
      id: String(id)
    },
    [id],
    { enabled: !!id }
  )

  const pageTitle = `${t('equipments.equipment')} - ${data?.name?.[currentLang.value]}`

  if (isLoading) return <Spin spinning fullscreen />

  return (
    <PageBreadcrumbs
      title={pageTitle}
      items={[{ title: t('menu.equipments') }, { title: pageTitle }]}
    >
      <Card>
        <Flex vertical gap={24}>
          <Card title={t('common.details')}>
            <Row gutter={[24, 24]}>
              <Col span={8}>
                <Flex vertical gap={4}>
                  <Text>{t('medicine_register.products.name')}</Text>
                  <Text weight={400}>{data?.name?.[currentLang.value]}</Text>
                </Flex>
              </Col>

              <Col span={8}>
                <Flex vertical gap={4}>
                  <Text>{t('equipments.device_type')}</Text>
                  <Text weight={400}>
                    {data?.type?.translation?.[currentLang.value]}
                  </Text>
                </Flex>
              </Col>

              <Col span={8}>
                <Flex vertical gap={4}>
                  <Text>{t('equipments.code')}</Text>
                  <Text weight={400}>{data?.code}</Text>
                </Flex>
              </Col>

              <Col span={8}>
                <Flex vertical gap={4}>
                  <Text>{t('equipments.last_inspection_date')}</Text>
                  <Text weight={400}>
                    {dayjs
                      .utc(data?.lastInspectionDate)
                      .tz()
                      .format(dayMonthYearFormatWithDot)}
                  </Text>
                </Flex>
              </Col>

              <Col span={16}>
                <Flex vertical gap={4}>
                  <Text>{t('common.description')}</Text>

                  <Text weight={400}>{data?.description || '-'}</Text>
                </Flex>
              </Col>
            </Row>
          </Card>

          <TechnicalInspectionsCard />
        </Flex>
      </Card>
    </PageBreadcrumbs>
  )
}
